<template lang="pug">
  div.login-pop
    div.content-wrapper
      div.body
        img.close(src="../assets/img/index/close.png", @click="$emit('close')")
        div.navs
          div.nav(v-for="n in navs",
            :key="n.key",
            :class="{active: nav.key === n.key}",
            @click.prevent="nav = n")
            span {{n.name}}
            div.bottom
        keep-alive
          Component(:is="nav.component",
            @toComponent="toComponent",
            @updateData="updateData"
            :data="data")
</template>

<script>
import AccountLogin from './AccountLogin'
import WechatLogin from './WechatLogin'
import AccountRegister from './AccountRegister'
import AccountForget from './AccountForget'
export default {
  name: 'LoginPop',
  data () {
    return {
      data: {
        data: '',
        nickname: '',
        headimgurl: ''
      },
      nav: {
        name: '账号登录',
        key: 0,
        component: AccountLogin
      },
      navs: [
        {
          name: '扫码登录',
          key: 1,
          component: WechatLogin
        },
        {
          name: '账号登录',
          key: 0,
          component: AccountLogin
        }
      ],
      components: {
        login: [
          {
            name: '扫码登录',
            key: 1,
            component: WechatLogin
          },
          {
            name: '账号登录',
            key: 0,
            component: AccountLogin
          }
        ],
        register: [
          {
            name: '账号注册',
            key: 2,
            component: AccountRegister
          }
        ],
        forget: [
          {
            name: '找回密码',
            key: 3,
            component: AccountForget
          }
        ]
      }
    }
  },
  methods: {
    toComponent (k, reset) {
      if (!reset) {
        this.data = {
          data: '',
          nickname: ''
        }
      }
      this.navs = [...this.components[k]]
      this.nav = this.navs[+(k === 'login')]
    },
    updateData (data) {
      this.data = data
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/scss/common";
  .login-pop{
    @extend %editWrapper;
  }
  .content-wrapper{
    display: flex;
    flex-flow:row nowrap;
    box-shadow: 3px 3px 5px rgba(0,0,0,0.2);
    border-radius: 10px;
    background-color: #ffffff;
    .body{
      width: 400px;
      position: relative;
      z-index: 12;
      .close{
        position: absolute;
        top: -24px;
        right: -24px;
        z-index: 12;
        cursor: pointer;
        width: 24px;
        height: 24px;
      }
      .navs{
        margin: 40px 0;
        display: flex;
        align-items: center;
        justify-content: center;
        .nav{
          margin: 0 36px;
          position: relative;
          font-size: 16px;
          color: #666;
          cursor: pointer;
          .bottom{
            width: 40px;
            height: 2px;
            background-color: #fff;
            margin: 8px 11px 0;
          }
          &.active{
            color: #3989cb;
            .bottom{
              background-color: #3989cb;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/EventIndex/LoginPop.vue